export default __webpack_public_path__ + "static/media/Mask-group.3f421bed.svg";